module.exports = __webpack_public_path__ + "daea1271c26cdba538d594c7fe643bf9.MP3";